import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Main from '../views/Main.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/reduction',
    name: 'Reduction',
    component: Main,
    props: {default:true, calc: 'reduce'}
  },
  {
    path: '/equations',
    name: 'Equations',
    component: Main,
    props: {default:true, calc: 'eqn'}
  },
  {
    path: '/inverse',
    name: 'Inverse',
    component: Main,
    props: {default:true, calc: 'inverse'}
  },
  {
    path: '/determinant',
    name: 'Determinant',
    component: Main,
    props: {default:true, calc: 'det'}
  },
]

const router = new VueRouter({
  routes
})

export default router
